// Dados de atendimento do Colégio Líder usados no rodapé e na página Contato.
// Para mudar o horário no site inteiro, altere só aqui.
export const HORARIO_ATENDIMENTO = {
  dias: 'Segunda a sexta-feira',
  horas: 'das 6h20 às 17h',
};

export const horarioTexto = () => `${HORARIO_ATENDIMENTO.dias}, ${HORARIO_ATENDIMENTO.horas}`;
